export const TimelapseIcon = (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.82659 4.17337C9.04659 3.39337 8.02659 3.00004 6.99992 3.00004V7.00004L4.17325 9.82671C5.73325 11.3867 8.26659 11.3867 9.83325 9.82671C11.3933 8.26671 11.3933 5.73337 9.82659 4.17337ZM6.99992 0.333374C3.31992 0.333374 0.333252 3.32004 0.333252 7.00004C0.333252 10.68 3.31992 13.6667 6.99992 13.6667C10.6799 13.6667 13.6666 10.68 13.6666 7.00004C13.6666 3.32004 10.6799 0.333374 6.99992 0.333374ZM6.99992 12.3334C4.05325 12.3334 1.66659 9.94671 1.66659 7.00004C1.66659 4.05337 4.05325 1.66671 6.99992 1.66671C9.94659 1.66671 12.3333 4.05337 12.3333 7.00004C12.3333 9.94671 9.94659 12.3334 6.99992 12.3334Z"
      fill="#F8981D"
    />
  </svg>
);

export const SpeakerNotesOffIcon = (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.227471 0.572471C-0.0325293 0.832471 -0.0325293 1.25247 0.227471 1.51247L0.634137 1.91914L0.634137 9.3658C0.634137 10.0991 1.23414 10.6991 1.96747 10.6991H9.41414L12.4875 13.7725C12.7475 14.0325 13.1675 14.0325 13.4275 13.7725C13.6875 13.5125 13.6875 13.0925 13.4275 12.8325L1.17414 0.572471C0.914137 0.312471 0.487471 0.312471 0.227471 0.572471ZM3.55414 4.83914L4.74747 6.03247H3.96747C3.6008 6.03247 3.3008 5.73247 3.3008 5.3658C3.3008 5.15247 3.4008 4.9658 3.55414 4.83914ZM3.96747 8.03247C3.6008 8.03247 3.3008 7.73247 3.3008 7.3658C3.3008 6.99914 3.6008 6.69914 3.96747 6.69914H5.41414L6.74747 8.03247H3.96747ZM9.18747 6.69914L8.5208 6.03247H10.6341C11.0008 6.03247 11.3008 5.73247 11.3008 5.3658C11.3008 4.99914 11.0008 4.69914 10.6341 4.69914L7.18747 4.69914L6.5208 4.03247H10.6341C11.0008 4.03247 11.3008 3.73247 11.3008 3.3658C11.3008 2.99914 11.0008 2.69914 10.6341 2.69914H5.18747L2.5208 0.0324707L12.6341 0.0324707C13.3675 0.0324707 13.9675 0.632471 13.9675 1.3658V11.4791L10.5208 8.03247H10.6341C11.0008 8.03247 11.3008 7.73247 11.3008 7.3658C11.3008 6.99914 11.0008 6.69914 10.6341 6.69914H9.18747Z"
      fill="#F27468"
    />
  </svg>
);

export const ErrorOutlineIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="17px"
    fill="current"
  >
    <path d="M0 0h24v24H0V0z" fill="none" />
    <path d="M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" />
  </svg>
);

export const ArrowForwardIcon = (
  <svg
    width="15"
    height="14"
    viewBox="0 0 15 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.66667 12L8.65556 10.9821L11.2375 8.42857H4.25C3.34722 8.42857 2.57986 8.11607 1.94792 7.49107C1.31597 6.86607 1 6.10714 1 5.21429C1 4.32143 1.31597 3.5625 1.94792 2.9375C2.57986 2.3125 3.34722 2 4.25 2H4.61111V3.42857H4.25C3.74444 3.42857 3.31713 3.60119 2.96806 3.94643C2.61898 4.29167 2.44444 4.71429 2.44444 5.21429C2.44444 5.71429 2.61898 6.1369 2.96806 6.48214C3.31713 6.82738 3.74444 7 4.25 7H11.2375L8.65556 4.42857L9.66667 3.42857L14 7.71429L9.66667 12Z"
      fill="#F8981D"
    />
  </svg>
);

export const ArrowBackIcon = (
  <svg
    width="15"
    height="14"
    viewBox="0 0 15 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.33333 2L6.34444 3.01786L3.7625 5.57143H10.75C11.6528 5.57143 12.4201 5.88393 13.0521 6.50893C13.684 7.13393 14 7.89286 14 8.78571C14 9.67857 13.684 10.4375 13.0521 11.0625C12.4201 11.6875 11.6528 12 10.75 12H10.3889V10.5714H10.75C11.2556 10.5714 11.6829 10.3988 12.0319 10.0536C12.381 9.70833 12.5556 9.28571 12.5556 8.78571C12.5556 8.28571 12.381 7.8631 12.0319 7.51786C11.6829 7.17262 11.2556 7 10.75 7H3.7625L6.34444 9.57143L5.33333 10.5714L0.999999 6.28571L5.33333 2Z"
      fill="#F8981D"
    />
  </svg>
);

export const InfoIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="17px"
    fill="current"
  >
    <path d="M0 0h24v24H0z" fill="none" />
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" />
  </svg>
);

export const PersonOffIcon = (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.23696 2.41005C5.71029 1.67672 6.53696 1.19672 7.47029 1.19672C8.94363 1.19672 10.137 2.39005 10.137 3.86338C10.137 4.79672 9.65696 5.62338 8.92363 6.09672L5.23696 2.41005ZM12.8036 9.97672C12.7903 9.24338 12.3836 8.57005 11.7303 8.23005C11.3703 8.04338 10.977 7.87005 10.5503 7.72338L12.8036 9.97672ZM13.1303 12.19L1.81029 0.870049C1.55029 0.610049 1.13029 0.610049 0.870293 0.870049C0.610293 1.13005 0.610293 1.55005 0.870293 1.81005L6.32363 7.26338C5.11029 7.41672 4.05029 7.79672 3.19029 8.23672C2.53696 8.58338 2.13696 9.27005 2.13696 10.01L2.13696 11.8634H10.917L12.1836 13.13C12.4436 13.39 12.8636 13.39 13.1236 13.13C13.3903 12.87 13.3903 12.45 13.1303 12.19Z"
      fill="#F27468"
    />
  </svg>
);

export const PinnedIcon = (
  <svg
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.8898 11.7099C8.11136 11.4884 8.13022 11.1489 7.97466 10.8708C7.54096 10.1071 7.64939 9.1219 8.29992 8.47136L10.6569 6.11434L11.1284 6.58575C11.3876 6.84502 11.8119 6.84502 12.0712 6.58575C12.3304 6.32647 12.3304 5.90221 12.0712 5.64294L7.35712 0.928893C7.09784 0.66962 6.67358 0.66962 6.41431 0.928893C6.15503 1.18817 6.15503 1.61243 6.41431 1.8717L6.88571 2.34311L4.52869 4.70013C3.87815 5.35067 2.89291 5.45909 2.12924 5.0254C1.85111 4.86983 1.5117 4.88869 1.29014 5.11025L1.22886 5.17153C0.969585 5.43081 0.969584 5.85507 1.22886 6.11434L3.57645 8.46194L0.286048 11.7712C0.0267751 12.0305 0.0267757 12.4547 0.286048 12.714C0.545321 12.9733 0.969584 12.9733 1.22886 12.714L4.51926 9.40474L6.88571 11.7712C7.14498 12.0305 7.56925 12.0305 7.82852 11.7712L7.8898 11.7099Z"
      fill="#323444"
    />
  </svg>
);

export default TimelapseIcon;
